export class TipoIdentificacion {
    public constructor(
        public id :number = 0,
        public cod_dni :String = "",
        public tipo_dni:String = "",
        public descripcion:String = "",
        public status:String = ""
    ){}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/tipo-identificacion.ts